export default {
  title: 'Weet je zeker dat je wilt uitloggen?',
  buttons: {
    logout: 'Uitloggen',
    cancel: 'Annuleren',
  },
};
